import Vue from 'vue';
import VueRouter from 'vue-router';
import VueAppInsights from 'vue-application-insights';
import VueGtm from '@gtm-support/vue2-gtm';
import policies from 'policies';
import { i18n } from '@/setup/i18n';
import routes from 'routes';
import store from 'store';
import { AUTH_VALIDATE } from 'store/actions/auth';
import { UI_GET_MASTER_DATA, UI_SET_LOADER } from 'store/actions/ui';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  hashbang: false,
  root: '/',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  routes
});

// Trackings
const appInsightsinStrKey = process.env.APP_INSIGHTS_INSTR_KEY;

if (process.env.NODE_ENV === 'production') {
  if (appInsightsinStrKey) Vue.use(VueAppInsights, { id: appInsightsinStrKey, router });

  const appGoogleTagManagerId = process.env.GOOGLE_TAG_MANAGER_ID;
  if (appGoogleTagManagerId) {
    const appGoogleTagManagerIdParsed = appGoogleTagManagerId && appGoogleTagManagerId.split(',');
    Vue.use(VueGtm, {
      id: appGoogleTagManagerIdParsed,
      defer: false,
      enabled: true,
      loadScript: true,
      vueRouter: router,
      trackOnNextTick: false
    });
  }
}

// Redirect to the error page
const redirectToErrorPage = (next, resource) =>
  next({
    name: 'error',
    params: { resource }
  });

router.beforeEach((to, from, next) => {
  const titleKey = to.meta.titleKey;
  const titleByKey = titleKey ? `| ${i18n.t(`title.${to.meta.titleKey}`)}` : '';
  document.title = `${process.env.APP_NAME} ${titleByKey}`;

  if (to.name === 'error') return next();

  // Valid always the Api token see action AUTH_VALIDATE in auth module
  return store
    .dispatch(`auth/${AUTH_VALIDATE}`)
    .then(() => {
      // Policies
      const metaStep = to.matched.some(m => m.meta.step);
      store
        .dispatch(`ui/${UI_GET_MASTER_DATA}`)
        .then(() => {
          if (metaStep) {
            policies.checkStep(to, from, next);
          } else {
            next();
          }
        })
        .catch(() => {
          // Redirect to the error page
          redirectToErrorPage(next, UI_GET_MASTER_DATA);
        });
    })
    .catch(() => {
      // Redirect to the error page
      redirectToErrorPage(next, AUTH_VALIDATE);
    });
});

// After navigation is confirmed, but before resolving...
router.beforeResolve((to, from, next) => {
  next();
});

// When each route is finished evaluating...
router.afterEach(to => {
  if (to.hash) {
    window.dispatchEvent(new HashChangeEvent('hashchange'));
  }
  // Loader hidden
  store.dispatch(`ui/${UI_SET_LOADER}`, false);
});

export { router as default };
